import React from "react";

export default function MSAccess_Minute() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Minute</h1>
      <p>This is the MSAccess_Minute component generated from the SQL JSON.</p>
    </div>
  );
}
